import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  { t: "Airports",       c: "var(--pw-navy)"   },
  { t: "Pubs",           c: "var(--pw-red)"    },
  { t: "Cafés",          c: "var(--pw-pink)"   },
  { t: "Holidays",       c: "var(--pw-orange)" },
  { t: "Festivals",      c: "var(--pw-purple)" },
  { t: "Train Journeys", c: "var(--pw-blue)"   },
  { t: "Cruises",        c: "var(--pw-navy)"   },
  { t: "Campsites",      c: "var(--pw-green)"  },
];

export const MarqueeBar = () => {
  return (
    <div
      data-testid="marquee-bar"
      className="py-2 md:py-5 border-y overflow-hidden"
      style={{
        backgroundColor: "var(--pw-yellow)",
        borderColor: "rgba(14,26,43,0.15)",
      }}
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {items.map((it, i) => (
          <span
            key={i}
            className="font-display font-black uppercase tracking-tight mx-8"
            style={{
              color: it.c,
              fontSize: "clamp(1.5rem, 3vw, 2.25rem)",
            }}
          >
            {it.t}{" "}
            <span
              className="inline-block align-middle mx-1"
              style={{
                width: 10, height: 10, borderRadius: 999, backgroundColor: it.c,
              }}
            />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBar;
